<template>
  <div>
    <div class="inner-content">
      <h2>{{ $t('notification_management') }}</h2>
      <div class="news-form-area">
        <form @change="onChangeForm()">
          <div class="contact-form-pos">
            <div class="notifications-checkbox-area">
              <label>
                <input type="checkbox" class="checkbox-input" :checked="isSendToMail" v-model="isSendToMail" :disabled="parseInt(status) == 1"/>
                <span class="checkbox-parts">{{ $t('notify_delivery_by_email') }}</span>
              </label>
            </div>
            <div class="notifications-group">
              <label for="">{{ $t('title_100_characters') }}</label>
              <input type="text" v-model="title" :disabled="parseInt(status) == 1" @blur="onBlurTitle()"/>
              <span v-if="messageErrorTitle" class="text-danger small ">{{messageErrorTitle}}</span>
            </div>
            <div class="notifications-group">
              <div class="w-100 mb-2">
                <label class=" mb-1 mr-3" for="">{{ $t('body_10000_characters') }}</label>
                <div v-if="parseInt(status) != 1" class="notifications-checkbox-area d-inline-flex mb-0 mr-3">
                  <label>
                    <input type="checkbox" class="checkbox-input" id="checkbox-nobody" :checked="isNoBody" v-model="isNoBody"/>
                    <span class="checkbox-parts d-inline">{{ $t('no_body') }}</span>
                  </label>
                </div>
                <span v-if="parseInt(status) != 1" class="text-danger small ">{{ $t('if_you_check_no_text_you_cannot_edit_the_text') }}</span>
              </div>
              <vue-editor
                v-model="content"
                useCustomImageHandler
                @image-added="handleImageAdded"
                @text-change="onChangeForm()"
                @blur="onBlurBody()"
                :disabled="(parseInt(status) == 1 || isNoBody)"
                :editorOptions="editorSettings"
                :editor-toolbar="customToolbar"
              >
              </vue-editor >
              <span v-if="messageErrorBody" class="text-danger small ">{{messageErrorBody}}</span>
            </div>
            <div class="notifications-group">
              <div class="w-100  mb-2">
                <label class=" mb-1 mr-3" for="">{{ $t('attachment_up_to_10_mb') }}</label>
                <span v-if="parseInt(status) != 1" class="text-danger small ">{{ $t('in_the_case_of_no_text_only_one_file_can_be_attached') }}</span>
              </div>
              <ul>
                <el-upload
                  action="#"
                  :disabled="parseInt(status) == 1 || (isNoBody && fileList.length >= 1)"
                  :accept="'.jpeg, .jpg, .png, .pdf'"
                  :on-change="handleChangeUploadFile"
                  :file-list="fileList"
                  :show-file-list="false"
                  :auto-upload="false"
                >
                  <el-button @click="onClickButtonUpload" class="btn-base upload-file-notice " :style="$t('__locale') == 'en' ? 'font-size: 15px !important;' : ''">{{ $t('upload_attachments') }}</el-button>
                </el-upload>
                <li v-for="(file, index) in fileList" :key="index">
                  <div class="file-name">
                    <div class="file-icon">
                      <p class="name">
                        <a class="icon_document mr-2">{{file.name}}</a>
                      </p>
                    </div>
                    <div class="remove-icon">
                      <i class="icon_btn_cancel" @click="handleRemoveUploadFile(file)"></i>
                    </div>
                  </div>
                  <div v-if="file.percentage !== maxUpload && !file.url" class="progress-bar-upload">
                    <b-progress class="progress-bar-css" :max="maxUpload">
                      <b-progress-bar :value="file.percentage" :label="`${file.percentage}%`" :max="maxUpload" show-progress animated></b-progress-bar>
                    </b-progress>
                  </div>
                </li>
              </ul>
            </div>
            <div v-if=" parseInt(status) != 1 && messageErrorFileUpload" class="notifications-group">
              <span class="text-danger small ">{{messageErrorFileUpload}}</span>
            </div>
            <div v-if="parseInt(status) != 1" class="notifications-group">
              <button v-if="isEditPage()" type="button" class="btn-delete" @click="clickButton('delete')">
                <p>{{ $t('delete') }}</p>
              </button>
              <button :disabled="disableButton" type="button" class="btn-save-draft" @click="clickButton('save-draft')">
                <p>{{ $t('save_draft') }}</p>
              </button>
              <button :disabled="disableButton" type="button" class="btn-delivery" @click="clickButton('delivery')">
                <p>{{ $t('delivery') }}</p>
              </button>
            </div>
          </div>
          <button :disabled="disableButton" type="button" class="notice-form-btn btn-return" @click="clickButton('return')">
            <p>{{ $t('back_to_index') }}</p>
          </button>
        </form>
        <!-- MODAL -->
        <b-modal id="modal-notice-form" class="modal-content center" centered :hide-header="true" :hide-footer="true" style="width:60%; top: 50%">
          <div class="modal-inner">
            <p class="modal-ttl">{{modalContent}}</p>
            <!-- show 2 buttons -->
            <div v-if="isShowTwoButton" class="modal-btn-area clearfix">
              <div class="btn-base pos-left">
                <a href="javascript:;" @click="onAccess(modalAction)"><p>{{ $t('ok') }}</p></a>
              </div>
              <div class="btn-cancel pos-right"><a href="javascript:;" @click="onCancelModal()" class="modal-close"><p>{{ $t('cancel') }}</p></a></div>
            </div>
            <!-- show 1 button -->
            <div v-else class="modal-btn-area clearfix">
              <div class="btn-base pos-center">
                <a href="javascript:;" @click="onAccess(modalAction)"><p>{{ $t('ok') }}</p></a>
              </div>
            </div>
          </div>
        </b-modal>
        <!-- MODAL -->
        <!-- MODAL NOTICE NOT FOUND -->
        <NotFoundDialog modalId="notice-edit-undefined" :content="$t('i_do_not_find_this_notification')" backToPath="/notifications/management" />
        <!-- MODAL -->
         <!-- MODAL LOADING IMAGE -->
        <b-modal @hide="() => {isCancelInsertImage = true}" id="modal-loading-image" class="modal-content center" no-close-on-backdrop centered :hide-header="false" :hide-footer="true" style="width:60%; top: 50%">
          <div class="modal-inner">
            <p class="modal-ttl">{{ $t('i_am_uploading_an_image') }}</p>
            <div class="progress-bar-upload">
              <b-progress class="progress-bar-css" :max="maxUpload">
                <b-progress-bar :value="processingInsertImage" :label="`${processingInsertImage}%`" :max="maxUpload" show-progress animated></b-progress-bar>
              </b-progress>
            </div>
          </div>
        </b-modal>
        <!-- MODAL -->
      </div>
    </div>
    <Spinner :isLoading="isLoading"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { BModal, VBModal, BButton} from 'bootstrap-vue'
import Spinner from '@/js/components/Spinner'
import { VueEditor, Quill } from "vue2-editor";
import NotFoundDialog from '@/js/components/Common/NotFoundDialog'
import ImageResize from 'quill-image-resize'

const sizeStyle = Quill.import('attributors/style/size')
sizeStyle.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
Quill.register(sizeStyle, true)
Quill.register("modules/imageResize", ImageResize)

export default {
  components: {
    BModal,
    VBModal,
    BButton,
    Spinner,
    VueEditor,
    NotFoundDialog
  },
  data() {
    return {
      isCancelInsertImage: false,
      processingInsertImage: 0,
      maxUpload: 100,
      listFilePath: [],
      disableButton: false,
      noticeDetail: null,
      isShowTwoButton: false,
      isLoading: false,
      isDataFormChange: false,
      isSendToMail: true,
      isNoBody: false,
      title: '',
      content: '',
      contentTemp: '',
      status: '',
      fileList: [],
      totalFileSize: 0,
      messageErrorTitle: null,
      messageErrorBody: null,
      messageErrorFileUpload: null,
      modalAction: '',
      modalContent: '',
      editorSettings: {
        modules: {
          imageResize: {
            modules: [ 'Resize', 'DisplaySize' ]
          },
          keyboard: {
            bindings: {
              'list autofill': {
                prefix: /^\s*()$/
              }
            }
          }
        },
        formats : [
          "bold",
          "italic",
          "underline",
          "size",
          "list",
          "align",
          "link",
          "image",
        ],
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ 'size': [ false, '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px'] }],
        [{ list: "bullet" }],
        [{ align: "" },{ align: "center" },{ align: "right" },{ align: "justify" }],
        ["link"],
        ["image"]
      ]
    }
  },
  watch: {
    isNoBody() {
      if (this.isNoBody) {
        if (this.fileList.length > 1) {
          this.clickButton("check-list-file-for-no-body")
          this.isNoBody = false
          document.getElementById('checkbox-nobody').checked = false
          return
        }
        else {
          this.fileList.length > 0 ? this.isFileUploadValid(this.fileList[0], false) : null
          document.getElementsByClassName("ql-container")[0]?.setAttribute("style", "background-color: #CCC;")
          this.contentTemp = this.content
          this.content = ''
        }
      }
      else {
        document.getElementsByClassName("ql-container")[0]?.setAttribute("style", "background-color: white;")
        this.content = this.contentTemp
      }
      this.onBlurBody()
    },
    modalAction() {
      switch (this.modalAction) {
        case 'save-draft':
        case 'check-list-file-for-no-body':
        case 'alert-image-insert-invalid':
          this.isShowTwoButton = false
          break;
        default:
          this.isShowTwoButton = true
          break;
      }
    }
  },
  computed: {
    ...mapState({
      detailNotificationManagement: state => state.notification.detailNotificationManagement,
    }),
  },
  async created() {
    this.screenTracking(this.$t('notification_management'))
    if(this.isEditPage()) {
      this.isLoading = true
      await this.$store.dispatch('notification/getDetailNotificationForManagement', this.$route.params.id)
        .catch(err => {
          err.response.status == 401 ? this.$router.push('/404') : null
          return
        })
      this.isLoading = false
      if (this.detailNotificationManagement === undefined) {
        this.$bvModal.show('notice-edit-undefined')
        return
      }
      else {
      this.noticeDetail = this.detailNotificationManagement
      }
    }
    else {
      this.noticeDetail = {
        send_email: 1,
        title: '',
        content: '',
        status: 0,
        file: [],
      }
    }
    this.isSendToMail = parseInt(this.noticeDetail.send_email) == 1 ? true : false
    this.title = this.noticeDetail.title || ''
    this.content = this.noticeDetail.content || ''
    this.isNoBody = ((this.noticeDetail.content || this.noticeDetail.file.length != 1) ? false : true)
    this.status = this.noticeDetail.status || 0
    this.noticeDetail.file === undefined ? this.noticeDetail.file = this.noticeDetail.files : null
    if (this.noticeDetail.file.length > 0 ) {
      this.noticeDetail.file.forEach( file => {
        this.totalFileSize = this.totalFileSize + parseInt(file.size)
        this.fileList.push({
          name: this.getFileName(file.access_url),
          url: this.getFilePath(file.access_url),
          size: parseInt(file.size),
          base64: null
        })
      })
    }
    else {
      this.fileList = []
    }
  },
  methods: {
    onBlurTitle() {
      if(!this.title) {
        this.messageErrorTitle = this.$t('please_enter_a_title_title_is_required')
      }
      else if(this.title.length > 100) {
        this.messageErrorTitle = this.$t('please_enter_the_title_with_100_characters_or_less')
      }
      else {
        this.messageErrorTitle = null
      }
    },
    onBlurBody() {
      if(!this.content && !this.isNoBody) {
        this.messageErrorBody = this.$t('please_enter_the_text_text_is_required')
      }
      else if(this.getContentText().length > 10000) {
        this.messageErrorBody = this.$t('please_enter_the_text_using_10000_characters_or_less')
      }
      else {
        this.messageErrorBody = null
      }
    },
    checkFileList() {
      if (this.isNoBody && this.fileList.length != 1) {
        this.messageErrorFileUpload = this.$t('if_no_text_please_upload_the_attached_file')
      }
      else {
        this.messageErrorFileUpload = null
      }
    },
    getFileName(file) {
      let fullName = file.substring(file.lastIndexOf("/")+1)
      if(fullName.indexOf('-') < 0 ) {
        return fullName.replaceAll(" ","_")
      }
      else {
        return decodeURIComponent(fullName.substring(fullName.indexOf('-')+1, fullName.indexOf('?X-Amz-Content-Sha'))).replaceAll(" ","_")
      }
    },
    getFilePath(file) {
      return decodeURIComponent(file.substring(file.indexOf("/notifications/")+1,file.indexOf('?X-Amz-Content-Sha')))
    },
    onChangeForm () {
      this.isDataFormChange = true
    },
    isEditPage() {
      return this.$route.path.includes('/notifications/management/edit')
    },
    getContentText(){
      return document.getElementsByClassName('ql-editor')[0].textContent
    },
    isFormDataValid() {
      return (
        this.title &&
        this.title.length <= 100 &&
        (
          (this.isNoBody && this.fileList.length == 1) ||
          (!this.isNoBody && this.content && this.getContentText().length <= 10000)
        )
      )
    },
    handleChangeUploadFile(file, fileList) {
      if(this.isFileUploadValid(file, true)) {
        let fileRaw = file.raw
        let reader = new FileReader()
        reader.onloadend = function() {
          let searchFile = fileList.find((f) => f.uid == file.uid)
          searchFile.name = file.name.replaceAll(" ","_")
          searchFile.base64 = reader.result
          searchFile.url = null
        }
        reader.readAsDataURL(fileRaw)
        this.fileList = fileList
        this.disableButton = true
				this.actionUploadFiles(file)
      }
    },
    onClickButtonUpload(file) {
      this.messageErrorFileUpload = null
    },
    handleRemoveUploadFile(file) {
      if( parseInt(this.status) != 1) {
        this.totalFileSize = this.totalFileSize - file.size
        this.fileList = this.fileList.filter(f => f.uid != file.uid)
        this.messageErrorFileUpload = null
        this.listFilePath = this.listFilePath.filter(f => f.uid != file.uid)
      }
    },
    isFileUploadValid(e, isUploading) {
      if(this.status === 1 || e.url) {
        return true
      }
      let fileExtension = e.name.substring(e.name.lastIndexOf('.')+1).toLowerCase()
      let isImageType = e?.raw?.type.split('/')[0] === 'image' || fileExtension === 'heic' || fileExtension === 'heif'
      if (
        !this.isTotalFileValid(e, isUploading) ||
        !this.isFileValid(e, fileExtension, isImageType)
      ) {
        return false
      }
      else {
        return true
      }
    },
    isTotalFileValid(e, isUploading) {
      let sizeValid = true
      if(e.size && isUploading) {
        this.totalFileSize = this.totalFileSize + e.size;
        sizeValid =	this.totalFileSize / Math.pow(1024,2).toFixed(2) < 10
      }
      if (!sizeValid) {
        this.handleRemoveUploadFile(e)
        this.messageErrorFileUpload = this.$t('files_larger_than_10_mb_cannot_be_attached')
        return false
      }
      else {
        return true
      }
    },
    isFileValid(e, fileExtension, isImageType) {
      const fileSupportUpload = [ 'pdf', 'jpeg', 'jpg', 'png' ]
      if (fileSupportUpload.indexOf(fileExtension) === -1) {
        this.handleRemoveUploadFile(e)
        this.messageErrorFileUpload = isImageType ? this.$t('when_attaching_an_image_file_only_jpeg_png_and_jpg_can_be_uploaded') : this.$t('only_pdf_files_and_image_files_can_be_attached');
        return false
      }
      else {
        return true
      }
    },
    isTotalSizeInsertToContentValid(file) {
      let totalSize = 0;
      document.querySelectorAll('.ql-editor p img').forEach((img , index) => {
        parseInt(img.getAttribute('size')) > 0 ? totalSize += parseInt(img.getAttribute('size')) : null
      })
      totalSize += file.size
      let sizeValid =	totalSize / Math.pow(1024,2).toFixed(2) < 10
      if (!sizeValid) {
        this.modalContent = this.$t('files_larger_than_10_mb_cannot_be_attached')
        this.modalAction = 'alert-image-insert-invalid'
        this.$bvModal.show('modal-notice-form')
        return false
      }
      else {
        return true
      }
    },
    isImageInsertToContentValid(file) {
      const imageSupportUpload = [ 'jpeg', 'jpg', 'png' ]
      let fileExtension = file.name.substring(file.name.lastIndexOf('.')+1).toLowerCase()
      if(imageSupportUpload.indexOf(fileExtension) === -1) {
        this.modalContent = this.$t('when_attaching_an_image_file_only_jpeg_png_and_jpg_can_be_uploaded')
        this.modalAction = 'alert-image-insert-invalid'
        this.$bvModal.show('modal-notice-form')
        return false
      }
      else {
        return true
      }
    },
    async clickButton(action){
      this.modalAction = action
      switch(action) {
        case 'delete':
          this.modalContent = this.$t('do_you_want_to_delete_the_notification')
          break
        case'delivery':
          this.onBlurTitle()
          this.onBlurBody()
          this.checkFileList()
          if(this.isFormDataValid()) {
            this.modalContent = this.$t('would_you_like_to_receive_the_notification')
          }
          else {return}
          break
        case 'return':
          if (this.isFormDataValid() && this.isDataFormChange) {
            this.modalContent = this.$t('do_you_want_to_save_the_draft')
          }
          else {
            this.$router.push('/notifications/management')
            return
          }
          break
        case 'save-draft':
          this.onBlurTitle()
          this.onBlurBody()
          this.checkFileList()
          if(this.isFormDataValid()) {
            this.isLoading = true
            if(this.isEditPage()) {
              await this.actionUpdate(0)
                .then(res => {
                  this.isDataFormChange = false
                  this.modalContent = this.$t('i_saved_the_draft')
                })
            }
            else {
              await this.actionRegister(0)
                .then(res => {
                  this.isDataFormChange = false
                  this.modalContent = this.$t('i_saved_the_draft')
                })
            }
            this.isLoading = false
          }
          else {return}
          break
        case 'check-list-file-for-no-body':
          this.modalContent = this.$t('if_you_want_to_attach_multiple_files_you_need_to_enter_the_text')
          break
      }
      this.$bvModal.show('modal-notice-form')
    },
    async onAccess(action) {
      this.isLoading = true
      switch(action) {
        case'delete':
          await this.actionDelete()
          break
        case 'delivery':
          await this.actionDelivery()
          .then(res => {
            this.$router.push('/notifications/management')
          })
          break
        case 'return':
          await this.actionReturn()
          break
        case 'save-draft':
          this.$router.push('/notifications/management')
          break
      }
      this.isLoading = false
      this.$bvModal.hide('modal-notice-form')
    },
    async actionDelete() {
      await this.$store.dispatch('notification/deleteDetailNotificationMangement', this.$route.params.id)
        .then(res => {
          this.$router.push('/notifications/management')
        })
        .catch(err => {
          err.response.status == 401 ? this.$router.push('/404') : null
        })
    },
    async actionDelivery() {
      if( !this.isEditPage()) {
        await this.actionRegister(1)
      }
      else {
        await this.actionUpdate(1)
      }
    },
    async actionRegister(status) {
      const filePath = this.listFilePath.map((item) => { return item.file_path })
      await this.$store.dispatch('notification/registerNotificationMangement', {
        send_email: this.isSendToMail == true ? 1: 0,
        title: this.title,
        content: this.content,
        status: status,
        fileURLs: filePath,
        domain_name: window.location.origin+'/notifications/region'
      })
        .then( res => {
        })
        .catch(err => {
          err.response.status == 401 ? this.$router.push('/404') : null
        })
    },
    async uploadFileToS3(uid, preSigned) {
			const fileData = this.fileList.find((file) => file.uid === uid)
			let self = this
			await axios.put(preSigned, fileData.raw, {
        headers: {
          'Content-Type': fileData.raw.type
        },
        onUploadProgress: function( progressEvent ) {
          fileData.percentage = parseInt(Math.round(( progressEvent.loaded / progressEvent.total) * 100))
        }.bind(self)
      })
      .then(function (response) {
        const uploadSuccess = self.fileList.filter(function(value) { return (value.percentage === self.maxUpload || value.url) })
        if (self.fileList.length === uploadSuccess.length) {
          self.disableButton = false
        }
      })
      .catch(function (error) {
        console.log(error)
      })
		},
    async actionUpdate(status) {
      this.fileList.forEach(f => {
        if(f.url !== null) {
          this.listFilePath.push({ file_path: f.url, uid: f.uid })
        }
      })
      const filePath = this.listFilePath.map((item) => { return item.file_path })
      await this.$store.dispatch('notification/updateNotificationMangement', {
        id: this.$route.params.id,
        data: {
          send_email: this.isSendToMail == true ? 1 : 0,
          title: this.title,
          content: this.content,
          status: status,
          fileURLs: filePath,
          domain_name: window.location.origin+'/notifications/region'
        }
      })
        .then(res => {
          if (status === 1) {
            this.$router.push('/notifications/management')
          }
        })
        .catch(err => {
          err.response.status == 401 ? this.$router.push('/404') : null
        })
    },
    async actionReturn() {
      if( !this.isEditPage()) {
        await this.actionRegister(0)
      }
      else {
        await this.actionUpdate(0)
      }
      this.isDataFormChange = false
      this.$router.push('/notifications/management')
    },
    async actionUploadFiles(file) {
			let listFileBase64 = []
			listFileBase64.push({name: file.name, uid: file.uid })
			if(listFileBase64.length != 0) {
				let result = await this.$store.dispatch('notification/postUploadFiles', {fileNames: listFileBase64})
                      .catch(err => {
                        err.response.status == 401 ? this.$router.push('/404') : null
                        return
                      })
				const listUrlFileUploaded = result.data.data
				this.listFilePath.push({ file_path: listUrlFileUploaded[0].file_path, uid: listUrlFileUploaded[0].uid })
				this.uploadFileToS3(listUrlFileUploaded[0].uid, listUrlFileUploaded[0].pre_signed)
			}
		},
    onCancelModal() {
      this.modalAction === 'return' ? this.$router.push('/notifications/management') : this.$bvModal.hide('modal-notice-form')	
    },
    async handleImageAdded (file, Editor, cursorLocation, resetUploader) {
      if(
        !this.isImageInsertToContentValid(file) ||
        !this.isTotalSizeInsertToContentValid(file)
      ) {
        resetUploader()
        return
      }
      this.processingInsertImage = 0
      this.isCancelInsertImage = false
      this.$bvModal.show('modal-loading-image')
      let listFileBase64 = []
      //replace all special character on the file name
      listFileBase64.push({name: file.name.replace(/[^\w\s]/gi, '_'), uid: file.lastModified })
      let result = await this.$store.dispatch('notification/postUploadFiles', {fileNames: listFileBase64})
      const listUrlFileUploaded = result.data.data
      let reader = new FileReader()
      let self = this
      reader.onload = async function () {
        let axiosSource = axios.CancelToken.source();
        await axios.put(listUrlFileUploaded[0].pre_signed, file, {
          cancelToken: axiosSource.token,
          headers: {
            'Content-Type': file.type
          },
          onUploadProgress: function( progressEvent ) {
            if (!this.isCancelInsertImage) {
              this.processingInsertImage = parseInt(Math.round(( progressEvent.loaded / progressEvent.total) * 100))
            }
            else {
              axiosSource.cancel();
              resetUploader()
            }
          }.bind(self)
        })
        .then(res => {
          if (!self.isCancelInsertImage) {
            self.getFileS3(file, listUrlFileUploaded[0].file_path, Editor, cursorLocation, resetUploader)
          }
          resetUploader()
        })
        .catch(function(error) {
          console.log(error)
        })
      }
      reader.readAsDataURL(file)
    },
    async getFileS3 (file, filePath, Editor, cursorLocation, resetUploader) {
      let imageUrl = await this.$store.dispatch('notification/getFileFromS3', filePath )
        .then(res => {
          Editor.insertEmbed(cursorLocation, 'image', res.data.data)
          this.$bvModal.hide('modal-loading-image')
          return res.data.data
        })
        let image = document.querySelector("[src='"+imageUrl+"']")
        image.setAttribute('size', file.size)
        image.setAttribute('width', 'auto')
        image.setAttribute('height', 'auto')
    }
  },
}
</script>
<style scoped>
  .notifications-group{
    width: 100%;
    margin-bottom: 20px;
    display: inline-block;
  }
  .notifications-group label{
    margin-bottom: 5px;
  }
  .notifications-group input {
    width: 100%;
    height: 40px;
    border: 1px solid #CCCCCC;
  }
  .notifications-group input:disabled{
     background:  #fff;
  }
  .notifications-group span {
    display: inline-flex;
    margin-top: 1px;
  }
  .notifications-group .quillWrapper {
    width: 100%;
    background-color: white;
    margin-bottom: 5px;
  }

  .notifications-group ul {
    list-style: none;
  }
  .notifications-group ul li:first-child{
    height: 40px;
  }
  .notifications-group ul li{
    min-height: 40px;
    line-height: 40px;
    margin: 5px 20px 0px 5px;
  }
  .notifications-group ul li .icon_document {
    background-size: 25px 25px;
    padding: 4px 0px 4px 30px;
  }
  .notifications-group ul li .file-name {
    width: 25%;
    float: left;
  }
  .notifications-group ul li .progress-bar-upload {
    width: 75%;
    float: left;
  }
  .notifications-group ul li .file-icon {
    float: left;
    width: 80%;
  }
  .notifications-group ul li .remove-icon {
    float: left; 
    width: 20%;
  }
  .notifications-group ul li .name {
    vertical-align: bottom; 
    display: inline-block; 
    overflow: hidden; 
    text-overflow: ellipsis; 
    white-space: nowrap; 
    max-width: 100%;
  }
  .notifications-group ul li .progress-bar-css {
    width: 25%;
    margin-top: 10px;
    margin-left: 10px;
  }
  .upload-file-notice {
    background-color: #FFA300;
    width: 220px !important;
    height: 40px !important;
    color: white;
    font-size: 14px !important;
    text-align: center;
    border-radius: 0px;
    border: 0px;
  }
  .upload-file-notice:hover, .upload-file-notice:focus {
    color: white !important;
  }
  .notifications-group button, .notice-form-btn {
    width: 200px;
    height: 50px;
    border: 0px;
    font-size: 1.2rem;
    margin: 0 10px 10px 0;
  }
  .notifications-group .btn-delete{
    background-color: red;
    color: white;
  }
  .notifications-group .btn-save-draft {
    background-color: white;
    color: black;
    border: 1px solid #FF8EA1;
  }
  .notifications-group .btn-delivery {
    background-color: #FF8EA1;
    color: white;
  }
  .notifications-group .btn-return {
    background-color: #CCCCCC;
    color: black;
  }
</style>